function isEnabledObject(value: unknown): value is { enabled: unknown } {
  return typeof value === "object" && value !== null && "enabled" in value;
}

// LaunchDarkly stores some demo flags as `{ enabled: boolean }`. URL overrides
// (`?sb_ff_on=` / `?sb_ff_off=`) write a plain boolean instead.
export function isDemoFlagEnabled(value: unknown): boolean {
  if (isEnabledObject(value)) {
    return value.enabled === true;
  }
  return value === true;
}
